import React, { useState, useEffect } from 'react';
import './Phase1.css';
import { LEAGUE_POSITIONS, POINT_SYSTEM } from '../../constants';
import Button from '../../../../components/Button/Button';
import PointSummary from '../PointSummary/PointSummary';

const Phase1 = ({ leagueStanding, onLeagueStandingChange,  isSaved, onSaveGuess, teams }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [selectedTeamsCount, setSelectedTeamsCount] = useState(0);
  
  // Check if all 36 teams are selected
  useEffect(() => {
    const selectedCount = leagueStanding.filter(team => team && team !== '').length;
    setSelectedTeamsCount(selectedCount);
    
    const allTeamsSelected = selectedCount === LEAGUE_POSITIONS.TOTAL_TEAMS;
    setIsButtonDisabled(!allTeamsSelected);
  }, [leagueStanding]);
  
  // Get available teams for each position (exclude already selected teams)
  const getAvailableTeams = (currentIndex) => {
    const selectedTeams = leagueStanding.filter((team, index) => 
      team && index !== currentIndex
    );
    return teams.filter(team => !selectedTeams.includes(team));
  };
  
  return (
    <div className="phase-container">
      <h3>Fase 1 - Liga</h3>
      {isSaved ? (
        <div className="saved-status">
          <p>✅ <strong>Gæt gemt!</strong> Du har valgt ligastillingen for alle {LEAGUE_POSITIONS.TOTAL_TEAMS} hold.</p>
          <p>Dette gæt kan ikke ændres.</p>
        </div>
      ) : (
        <p>Gæt rækkefølgen af alle {LEAGUE_POSITIONS.TOTAL_TEAMS} hold:</p>
      )}
      <div className="league-standing">
        {Array.from({ length: LEAGUE_POSITIONS.TOTAL_TEAMS }, (_, index) => {
          const availableTeams = getAvailableTeams(index);
          const currentTeam = leagueStanding[index];
          
          return (
            <div key={index} className="standing-row">
              <span className="position">{index + 1}.</span>
              <select
                value={currentTeam || ''}
                onChange={(e) => {
                  if (!isSaved) {
                    onLeagueStandingChange(index, e.target.value);
                  }
                }}
                disabled={isSaved}
              >
                <option value="">Vælg hold</option>
                {availableTeams.map((team, teamIndex) => (
                  <option key={teamIndex} value={team}>
                    {team}
                  </option>
                ))}
                {/* Show currently selected team even if it's not in available teams */}
                {currentTeam && !availableTeams.includes(currentTeam) && (
                  <option value={currentTeam}>
                    {currentTeam}
                  </option>
                )}
              </select>
              <div className="point-info">
                {index < LEAGUE_POSITIONS.TOP_8 && (
                  <span className="top-8">Top-{LEAGUE_POSITIONS.TOP_8}: +{POINT_SYSTEM.LEAGUE_TOP_8_BONUS} point</span>
                )}
                {index >= LEAGUE_POSITIONS.PLAYOFF_START && index < LEAGUE_POSITIONS.PLAYOFF_END && (
                  <span className="playoff">Playoff: +{POINT_SYSTEM.LEAGUE_PLAYOFF_BONUS} point</span>
                )}
                {index >= LEAGUE_POSITIONS.OUT_START && (
                  <span className="out">Out: +{POINT_SYSTEM.LEAGUE_OUT_BONUS} point</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <PointSummary
        rules={[
          { text: `${POINT_SYSTEM.LEAGUE_EXACT_POSITION} point for præcis placering` },
          { text: `+${POINT_SYSTEM.LEAGUE_TOP_8_BONUS} point hvis holdet er i Top-${LEAGUE_POSITIONS.TOP_8}` },
          { text: `+${POINT_SYSTEM.LEAGUE_PLAYOFF_BONUS} point hvis holdet er i Playoff-zonen (${LEAGUE_POSITIONS.PLAYOFF_START + 1}-${LEAGUE_POSITIONS.PLAYOFF_END})` },
          { text: `+${POINT_SYSTEM.LEAGUE_OUT_BONUS} point hvis holdet er i Out-zonen (${LEAGUE_POSITIONS.OUT_START + 1}-${LEAGUE_POSITIONS.TOTAL_TEAMS})` }
        ]}
      />
      {!isSaved && (
        <div className="save-guess-section">
          {isButtonDisabled ? (
            <p>{selectedTeamsCount} ud af {LEAGUE_POSITIONS.TOTAL_TEAMS} hold valgt - vælg {LEAGUE_POSITIONS.TOTAL_TEAMS - selectedTeamsCount} mere for at gemme</p>
          ) : (
            <p><strong>Alle {LEAGUE_POSITIONS.TOTAL_TEAMS} hold er valgt!</strong></p>
          )}
          <Button 
            onClick={onSaveGuess}
            title="Gem dit gæt"
            variant="contained"
            color="confirmation"
            disabled={isButtonDisabled}
          />
        </div>
      )}
    </div>
  );
};

export default Phase1;
